<div class="flex items-center !gap-2 !min-h-[40px] !pl-2">
  <mat-icon *ngIf="data.type === SnackType.SUCCESS" class="!text-green-500 !text-2xl !min-w-[32px] !min-h-[32px]">check_circle</mat-icon>
  <mat-icon *ngIf="data.type === SnackType.INFO" class="!text-blue-500 !text-2xl !min-w-[32px] !min-h-[32px]">info</mat-icon>
  <mat-icon *ngIf="data.type === SnackType.ERROR" class="!text-red-500 !text-2xl !min-w-[32px] !min-h-[32px]">error_outline</mat-icon>

  <span class="!ml-2 !flex-1 !break-words whitespace-pre-line">{{data.message}}</span>
</div>